import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// rotina.service.js — r83
// Catálogo de rotinas + permissões por grupo
// ════════════════════════════════════════════════════════════════════════════

const rotinaService = {
  // Lista todas as rotinas ativas (com ações e filtros próprios)
  listar: async () => {
    const res = await api.get('/rotinas', { params: { _t: Date.now() } });
    return res.data;
  },

  // Força sincronização do catálogo (rodada manual)
  sincronizar: async () => {
    const res = await api.post('/rotinas/sincronizar');
    return res.data;
  },

  // Lê permissões de um grupo
  lerPermissoes: async (grupoId) => {
    const res = await api.get(`/rotinas/permissoes/${grupoId}`,
      { params: { _t: Date.now() } });
    return res.data;
  },

  // Salva permissões de UMA rotina pra UM grupo
  // dados = { rotina_codigo, permissoes: { acao_codigo: { permitido, filtro_proprio } } }
  salvarPermissoes: async (grupoId, dados) => {
    const res = await api.put(`/rotinas/permissoes/${grupoId}`, dados);
    return res.data;
  },
};

export default rotinaService;
